const NONE = 'none';

/* 
  we need to go through the manifest and find at least 1 appropriate
   display property to know if we need to should the elements panel
*/
const isValidDisplayPropertyItem = item => {
  var _item$display;
  return (_item$display = item.display) == null || (_item$display = _item$display.displayValues) == null ? void 0 : _item$display.includes(NONE);
};
const isValidCssGroup = group => Object.values(group).some(isValidDisplayPropertyItem);
export const shouldShowBuilderElementsPanel = (editorPointer, deps) => {
  const {
    getBehaviorValue,
    getChildren,
    getStyle
  } = deps;
  const {
    cssCustomProperties,
    cssProperties
  } = getStyle(editorPointer);
  const isRemovableValue = getBehaviorValue(editorPointer, 'removable');
  const isElementRemovable = isRemovableValue ?? true;
  const innerElements = getChildren(editorPointer, false);
  const isValidRemovableElement = isValidCssGroup(cssProperties) && isElementRemovable;
  return isValidRemovableElement || isValidCssGroup(cssCustomProperties) || innerElements.some(childPointer => shouldShowBuilderElementsPanel(childPointer, deps));
};
//# sourceMappingURL=shouldShowBuilderElementsPanel.js.map